import { styled, css } from 'styled-components';
import { Icon } from '../../Icon/Icon';
import { sizeMap } from '../types';
const getTransform = (overlap, position) => {
  const [vertical, horizontal] = position.split('-');
  let verticalTranslate, horizontalTranslate;
  vertical === 'top' ? verticalTranslate = '-50%' : verticalTranslate = '50%';
  horizontal === 'right' ? horizontalTranslate = '50%' : horizontalTranslate = '-50%';
  if (overlap === 'square') {
    return css(["transform:translate(", ",", ");", ":0;", ":0;"], horizontalTranslate, verticalTranslate, vertical, horizontal);
  }
  return css(["transform:translate(", ",", ");", ":14%;", ":14%;"], horizontalTranslate, verticalTranslate, vertical, horizontal);
};
const getColor = variant => {
  switch (variant) {
    case 'alert':
      return css(["background-color:var(--aui-status-error);color:var(--aui-status-on-error);"]);
    case 'warn':
      return css(["background-color:var(--aui-status-warning);color:var(--aui-status-on-warning);"]);
    case 'positive':
      return css(["background-color:var(--aui-status-success);color:var(--aui-status-on-success);"]);
    case 'neutral':
      return css(["background-color:var(--aui-neutral-soft);color:var(--aui-on-neutral-soft);border:1px solid var(--aui-outline);"]);
    default:
      return css(["background-color:var(--aui-primary);color:var(--aui-on-primary);"]);
  }
};
const getPadding = (size, hasIcon) => {
  if (size === 'sm' && !hasIcon) {
    return css(["padding:0 var(--aui-spacing-050);"]);
  } else if (size === 'md' && !hasIcon) {
    return css(["padding:0 var(--aui-spacing-075);"]);
  } else return css(["padding:0;"]);
};
const getSharedStyles = props => css(["display:flex;align-items:center;justify-content:center;box-sizing:border-box;border-radius:1rem;width:fit-content;min-height:", ";min-width:", ";", " ", ";", ""], sizeMap[props.$size], sizeMap[props.$size], props.$size === 'hint' && css(["outline:2px solid var(--aui-surface);"]), getColor(props.$variant || 'notification'), getPadding(props.$size, props.$hasIcon));
export const StyledBadge = styled.div.withConfig({
  componentId: "aui__sc-1mbhnf-0"
})(["position:absolute;", " ", ";"], getSharedStyles, props => getTransform(props.$overlap, props.$position));
export const StyledInline = styled.div.withConfig({
  componentId: "aui__sc-1mbhnf-1"
})(["", ""], getSharedStyles);
export const StyledText = styled.span.withConfig({
  componentId: "aui__sc-1mbhnf-2"
})(["font-size:", ";font-weight:700;line-height:1rem;vertical-align:middle;font-variant-numeric:tabular-nums lining-nums;"], ({
  $size
}) => $size === 'sm' ? '0.75rem' : '0.875rem');
export const StyledIcon = styled(Icon.SSR).withConfig({
  componentId: "aui__sc-1mbhnf-3"
})(["width:", ";height:", ";"], ({
  $size
}) => $size === 'sm' ? '0.625rem' : '0.75rem', ({
  $size
}) => $size === 'sm' ? '0.625rem' : '0.75rem');